export default {"src":"/_next/static/media/like.97291bfc.svg","height":28,"width":29,"blurWidth":0,"blurHeight":0};